import React from "react";
import { Outlet } from "react-router-dom";
import { LibraryProvider } from "../context/LibraryContext"; // adjust path if needed

const LibraryProviderLayout = () => (
  <LibraryProvider>
    <Outlet />
  </LibraryProvider>
);

export default LibraryProviderLayout;
